import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $types } from './Addresses.types'

@Injectable({ providedIn: 'root' })
export class Addresses_delete_owneraccount_flowService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { addressId: number, contactId: number, accountId: number, ownerId: number }): Promise<{ reason?: string }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.addressId)) {
      missingRequiredInParams.push('\'addressId\'');
    }
    if (isNil(inParams.contactId)) {
      missingRequiredInParams.push('\'contactId\'');
    }
    if (isNil(inParams.accountId)) {
      missingRequiredInParams.push('\'accountId\'');
    }
    if (isNil(inParams.ownerId)) {
      missingRequiredInParams.push('\'ownerId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Addresses/functions/delete_owneraccount_flow`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}

